export default "__VITE_ASSET__8Ax$rIRB__"